'use strict';

/** @typedef {'singleV7ProjectFlow' | 'singleCoreProjectFlow'} PipelineStatusFlowScenarioKey */

export const SINGLE_V7_PROJECT_FLOW_SCENARIO = 'singleV7ProjectFlow';

export const SINGLE_CORE_PROJECT_FLOW_SCENARIO = 'singleCoreProjectFlow';

/** @type {ReadonlySet<string>} */
export const PIPELINE_STATUS_FLOW_SCENARIO_KEYS = new Set([
	SINGLE_V7_PROJECT_FLOW_SCENARIO,
	SINGLE_CORE_PROJECT_FLOW_SCENARIO,
]);

/**
 * @param {unknown} key
 * @returns {string}
 */
export function requirePipelineStatusFlowScenarioKey(key) {
	const k = String(key ?? '').trim();
	if (!PIPELINE_STATUS_FLOW_SCENARIO_KEYS.has(k)) {
		throw new Error(
			`[pipelineStatus] Unknown pipeline status flow scenario ${JSON.stringify(
				key,
			)}. Expected one of: ${[...PIPELINE_STATUS_FLOW_SCENARIO_KEYS].join(', ')}`,
		);
	}
	return k;
}

/**
 * Maps Portal `ProjectDescription.pipeline` (`V7` | `Core`, case-insensitive) to the graph / adapter flow key.
 * Unknown or missing values follow PortalApi default and use the V7 project flow.
 *
 * @param {unknown} projectPipeline
 * @returns {PipelineStatusFlowScenarioKey}
 */
export function pipelineStatusFlowScenarioFromProjectPipeline(projectPipeline) {
	const p = String(projectPipeline ?? '').trim().toLowerCase();
	if (p === 'core') {
		return SINGLE_CORE_PROJECT_FLOW_SCENARIO;
	}
	return SINGLE_V7_PROJECT_FLOW_SCENARIO;
}
